import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";

import { CallToActionComponent } from "@hermes/aphrodite/call-to-action";
import { SearchInputComponent } from "@hermes/aphrodite/fields";
import { MessageBlockComponent } from "@hermes/aphrodite/message-block";

import {
    svgFoursticks,
    svgGeolocalization,
    SvgIconComponent,
    svgPinDark,
    svgPinMinimalist,
    SvgRegistryService,
} from "@hermes/aphrodite/svg";
import {
    AutoCompleteProviderService,
    GeoService,
    LoadGeoLibrariesServiceModule,
} from "@hermes/map-utils";
import { SrOnlyNoSnippetDirective } from "@hermes/utils-generic/directives/sr-only-no-snippet";
import { FormService } from "@hermes/utils-generic/services/user-interface";

import { PlacesSearchBarComponent } from "./places-search-bar.component";

@NgModule({
    imports: [
        CommonModule,
        LoadGeoLibrariesServiceModule,
        SvgIconComponent,
        MessageBlockComponent,
        SearchInputComponent,
        CallToActionComponent,
        ReactiveFormsModule,
        SrOnlyNoSnippetDirective,
    ],
    declarations: [PlacesSearchBarComponent],
    providers: [AutoCompleteProviderService, GeoService, FormService],
    exports: [PlacesSearchBarComponent],
})
export class PlacesSearchBarModule {
    constructor(svgRegistryService: SvgRegistryService) {
        svgRegistryService.registerSvgs([
            svgPinDark,
            svgGeolocalization,
            svgPinMinimalist,
            svgFoursticks,
        ]);
    }
}
